import { render } from "./CopyText.vue?vue&type=template&id=1b3f133e&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"

import "./CopyText.vue?vue&type=style&index=0&id=1b3f133e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3f133e"]])

export default __exports__